<ng-container *ngIf="!multiple; else withMultipleProducts">
  <ng-container
    *ngTemplateOutlet="
      summaryTemplate;
      context: {
        otherProduct: product,
        project: project,
        client: client,
        projectContactToCompanySubject: projectContactToCompanySubject
      }
    "
  ></ng-container>
</ng-container>

<ng-template #withMultipleProducts>
  <mat-card class="top-card mat-elevation-z0 multiple-products-summary-card">
    <ng-container
      *ngTemplateOutlet="
        summaryTemplate;
        context: {
          otherProduct: product,
          project: project,
          client: client,
          projectContactToCompanySubject: projectContactToCompanySubject
        }
      "
    ></ng-container>
  </mat-card>
</ng-template>

<ng-template
  #summaryTemplate
  let-otherProduct="otherProduct"
  let-project="project"
  let-client="client"
  let-projectContactToCompanySubject="projectContactToCompanySubject"
>
  <div class="summary-card-container">
    <div class="summary-card-header">
      Configuratie
    </div>
    <mat-card class="top-card mat-elevation-z0 summary-card black-border-color">
      <div class="bold-card-title">
        {{ product.type | productType: product.otherProductName }}
      </div>
      <div class="upper-space">
        {{
          otherProduct.type
            | productType: otherProduct.otherProductName
            | joiner
              : ' - '
              : otherProduct.otherProductMaterial
              : (otherProduct.height | formatProductSize: otherProduct.width)
        }}
      </div>
      <div *ngIf="otherProduct.layoutDescription?.length > 0">
        <span class="preserve-line-break inline-flex">{{
          otherProduct.layoutDescription
        }}</span>
      </div>
    </mat-card>
  </div>
  <client-non-ip-board-design-summary
    [product]="otherProduct"
    [project]="project"
    [client]="client"
    [projectContactToCompanySubject]="projectContactToCompanySubject"
  ></client-non-ip-board-design-summary>
</ng-template>
